import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfileContactSection,
} from './StaffProfileTemplate';

const AniruddhaGuhaProfile = () => {
  const person = {
    id: 'aniruddha-guha',
    name: 'Aniruddha Guha',
    honorific: null,
    title: 'Collaborative Doctoral Researcher',
    affiliation: "King's College London; The Highland Institute",
    image: 'https://customer-assets-0z36b82j.emergentagent.net/job_7a4f11f8-6c06-4e1c-b433-73d9453c195e/artifacts/d974d56c8ded902e_Aniruddha_Guha_Portrait_HI.webp',
    email: 'aniruddha.guha@kcl.ac.uk',
    category: 'Visiting & Collaborative Researchers',
    testid: 'aniruddha-guha-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      {/* Intellectual Biography */}
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            "Aniruddha Guha is an MPhil/PhD student at King's College London, holding the KDSAH Arts & Humanities PhD Studentship (Collaborative Doctoral Award) in partnership with The Highland Institute. He earned his MA in History from Presidency University, Kolkata.",
            "His research delves into the history of opium in colonial Nagaland, with a specific focus on the Veda peak region and the broader eastern Himalayan borderlands. His intellectual curiosity lies at the confluence of colonial history, borderland societies, and the political and economic forces that shaped this region.",
            "He employs a methodology that integrates archival research with oral histories and community-based knowledge to foster a dialogue between Indigenous and regional perspectives and colonial records.",
            "Beyond academia, Aniruddha is an experienced trekker and amateur mountaineer with a deep-seated interest in Northeast India, particularly Nagaland.",
          ]}
        />
      </ProfileSection>

      {/* Research Foci & Areas of Work */}
      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          items={[
            'South Asian history — examining historical processes and social transformations',
            'Borderlands — exploring relationships between communities, economies, and political boundaries in the eastern Himalayas',
            'Narcotic capitalism — investigating the cultivation, circulation, and consumption of opium within colonial economies',
            'State formation — examining the relationship between colonial governance, narcotics policies, and changing social relations',
            'Indigenous oral histories — bringing community knowledge and regional perspectives into historical research',
          ]}
        />
      </ProfileSection>

      {/* Highland Institute Projects */}
      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            <>
              <strong>Opium, State Formation, and Society in the Eastern Himalayan Borderlands, c. 1850–1947</strong>
            </>,
            "This doctoral research project, undertaken in partnership with The Highland Institute, traces the history of opium in colonial Nagaland, concentrating on the Veda peak region and the wider eastern Himalayan borderlands.",
            "It investigates the entanglement of opium cultivation, circulation, and consumption with colonial state formation and evolving social relations. The project examines the interaction between colonial narcotics policies and local societies, economies, and knowledge systems, situating Nagaland within broader historical narratives of imperialism, borderlands, and narcotic capitalism.",
            "The methodology involves archival research, oral histories, and engagement with community-based knowledge to facilitate a dialogue between colonial records and Indigenous/regional perspectives on opium's history and its lasting social and economic consequences.",
          ]}
        />
      </ProfileSection>

      {/* Education */}
      <ProfileSection title="Education">
        <ProfileBullets
          items={[
            "MPhil/PhD student, King's College London — KDSAH Arts & Humanities PhD Studentship (Collaborative Doctoral Award)",
            'MA in History, Presidency University, Kolkata',
          ]}
        />
      </ProfileSection>

      {/* Contact & Scholarly Infrastructure */}
      <ProfileContactSection
        email={person.email}
        role="Collaborative Doctoral Researcher, King's College London & The Highland Institute"
        testidPrefix="aniruddha"
      />
    </StaffProfileTemplate>
  );
};

export default AniruddhaGuhaProfile;
